import { Component, EventEmitter, Output, ViewChild, HostListener } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { ContactGrouopService } from 'src/app/private/services/contact-groups.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ContactGroupListComponent } from '../../components/contact-group-list/contact-group-list.component';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-contact-groups',
  templateUrl: './contact-groups.component.html',
  styleUrls: ['./contact-groups.component.scss']
})
export class ContactGroupsComponent {
  mobileContactListVisible: boolean = false;

  initalLoadGroup = true;
  selectedGroupId: any;
  selectedGroupType: 'email' | 'whatsapp' | 'both' = 'both'; // Store the group type for CSV import
  isRefresh = true;
  GroupListData: any;

  currentSelectedContactGroupID: any;

  @Output() reload: EventEmitter<any> = new EventEmitter();
  dataSource: MatTableDataSource<any> = new MatTableDataSource();

  @ViewChild(ContactGroupListComponent) contactGroupListComponent!: ContactGroupListComponent;

  GroupToEdit: any;

  allContactGroups: any;
  btnLoading = false;
  initialLoad = true;

  totalRows = 0;
  currentPage = 0;
  pageSize = 10;
  GroupToDelete: any;

  isAdmin: boolean = false; // Initialize isAdmin to false


  constructor(
    private toast: ToastrService,
    private api: ContactGrouopService,
    private modalService: NgbModal,
    private localStorage: LocalStorageService,
    private userApi: UsersService,
    private tracker: TrackingService
  ) {
    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  toggleContactList() {
    this.mobileContactListVisible = !this.mobileContactListVisible;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.left-box') && this.mobileContactListVisible) {
      this.mobileContactListVisible = false;
    }
  }

  ngAfterViewInit() {
    this.getAllContactGroups();
  }

  getAllContactGroups(type?: string) {

    const payload : any = {
      "where": {
        "hospital_id": this.localStorage.getHospitalId()
      },
      "filter": null,
      "page": 0,
      "limit": 10,
      "order": {
        "col": "\"contact_group\".\"createdAt\"",
        "dir": "DESC"
      }
    }

    if (!this.isAdmin) {
      payload.where.user_id = this.localStorage.getUserId();
    }

    this.api.getAllContactGroups(payload).subscribe(
      (res) => {
         this.allContactGroups = this. sortByCreatedAtDesc(res);

        this.initalLoadGroup = false;

        if (this.initialLoad) {
          this.currentSelectedContactGroupID = this.allContactGroups[0]?.id;
        }

        if (this.currentSelectedContactGroupID) {
          this.loadData();
        } else {
          this.initialLoad = false;
          this.dataSource = new MatTableDataSource<any>([]);
        }

        if (type === 'Create') {
          this.modalService.dismissAll();
          this.toast.success("Contact Group Created Successfully");
          this.tracker.track("Create", "Contact Group", `Created contact group: ${this.allContactGroups[0]?.group_name}`);
        }

        if (type === 'Edit') {
          this.modalService.dismissAll();
          this.toast.success("Contact Group Updated Successfully");
          this.tracker.track("Update", "Contact Group", `Updated contact group: ${this.GroupToEdit?.group_name}`);
        }

      },
      (err) => {
        console.error(err);
      }
    )
  }

  getAllContactGroupsForDelete(type?: string) {

    const payload : any = {
      "where": {
        "hospital_id": this.localStorage.getHospitalId()
      },
      "filter": null,
      "page": 0,
      "limit": 10,
      "order": {
        "col": "\"contact_group\".\"createdAt\"",
        "dir": "DESC"
      }
    }

    if (!this.isAdmin) {
      payload.where.user_id = this.localStorage.getUserId();
    }

    this.api.getAllContactGroups(payload).subscribe(
      (res) => {
        this.allContactGroups = this. sortByCreatedAtDesc(res);


        this.currentSelectedContactGroupID = this.allContactGroups[0].id;


        this.initalLoadGroup = false;

        this.loadData();

        this.toast.success("Contact Group Deleted Successfully");
        this.modalService.dismissAll();
        this.btnLoading = false;
        this.tracker.track("Delete", "Contact Group", `Deleted contact group: ${this.GroupToDelete?.group_name}`);

      },
      (err) => {
        console.error(err);
      }
    )
  }
sortByCreatedAtDesc(data: any[]) {
  return [...data].sort((a, b) => {
    const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;

    return dateB - dateA; // DESC
  });
}
  loadData(type?: string) {
    if (!this.currentSelectedContactGroupID) {
      this.initialLoad = false;
      this.dataSource = new MatTableDataSource<any>([]);
      this.isRefresh = false;
      return;
    }
    try {
      // this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            console.log("hospital_id", this.localStorage.getHospitalId())

            const payload = {
              "where": {
                "hospital_id": this.localStorage.getHospitalId(),
                "contact_group_id": this.currentSelectedContactGroupID
              },
              "filter": null,
              "page": this.currentPage * this.pageSize,
              "limit": this.pageSize,
              "order": {
                "col": "\"contact_group_list\".\"updatedAt\"",
                "dir": "DESC"
              }
            }


            return this.api
              .getAllContactGroupList(payload)
              .pipe(catchError(() => observableOf(null)));
          }),
          map((response: any) => {
            if (response === null) {
              return [];
            }
            this.totalRows = response.count;
            this.isRefresh = false;
            return response.rows;
          })
        )
        .subscribe({
          next: (data) => {
            this.initialLoad = false;
            this.dataSource = new MatTableDataSource<any>(data);
            this.GroupListData = data;

            if (type === 'Create') {


              this.modalService.dismissAll();
              this.btnLoading = false;
            }
          },
          error: (e) => {
            this.initialLoad = false;
            console.error(e);
          },
          complete: () => {
          },
        });
    } catch (e) {
      console.error(e);
    }
  }

  open(content: any) {
    this.modalService
      .open(content, { size: 'md', scrollable: true, centered: true })
  }


  addContacts(element: any, id: any) {
    console.log('Add Contacts clicked');

    this.selectedGroupId = id;

    this.modalService
      .open(element, { size: 'xl', scrollable: true, centered: true })

    this.tracker.track("Open Add Contacts", "Contact Group", `Opened Add Contacts for group ID: ${id}`);
    // Add your logic here
  }

  importContacts(element: any, id: any) {
    this.selectedGroupId = id;
    
    // Find the selected group and get its group_type
    const selectedGroup = this.allContactGroups.find((group: any) => group.id === id);
    this.selectedGroupType = selectedGroup?.group_type || 'both'; // Default to 'both' if not found
    
    this.modalService
      .open(element, { size: 'xl', scrollable: true, centered: true ,backdrop: 'static', keyboard: false})

    this.tracker.track("Open Import Contacts", "Contact Group", `Opened Import Contacts for group ID: ${id}`);
  }


  handleChangeGroup(id: any) {

    if (this.currentSelectedContactGroupID === id) {
      return;
    }

    this.isRefresh = true;
    if (this.contactGroupListComponent) {
      this.contactGroupListComponent.resetPaginator();
    }
    this.currentPage = 0;
    this.pageSize = 10;
    this.currentSelectedContactGroupID = id;
    this.loadData();
  }

  openEditGroup(content: any, event: any) {
    this.modalService
      .open(content, { size: 'md', scrollable: true, centered: true })

    this.GroupToEdit = event;
  }

  openDeleteGroup(content: any, event: any) {
    this.modalService
      .open(content, { size: 'md', scrollable: true, centered: true })

    this.GroupToDelete = event;
  }

  handleDeleteEvent() {

    const payload = {
      "id": this.GroupToDelete.id
    }

    this.btnLoading = true;

    this.api.deleteContactGroup(payload).subscribe(
      (res: any) => {

        this.getAllContactGroupsForDelete();


      },
      (err: any) => {
        console.error(err);
      }
    )
  }


}


function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}